import {useState} from 'react';
import {InputNumber, Modal} from 'antd';
import {UnitType} from "../../api/Constants";
import {getUnitPrecision} from "../../util/unitutils";

export const QuantityEntryWidget = ({title, value, placeholder, onQuantityChange, max, unit, useLabel=true, props}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [quantity, setQuantity] = useState(parseFloat(value));

    const onClick = () => {
        setIsModalOpen(true);
    }

    const onModalCancel = () => {
        setIsModalOpen(false);
    }

    const onModalOk = () => {
        if (onQuantityChange) {
            onQuantityChange(quantity);
        }
        setIsModalOpen(false);
    }

    const onQuantityValChange = (val) => {
        setQuantity(val);
    }

    if (placeholder === undefined) {
        placeholder = "quantity";
    }

    let defaultValue = (value) ? value : 0
    if ((unit !== undefined) && (unit !== UnitType.Each) && (useLabel === true)) {
        defaultValue = `${defaultValue} ${UnitType.Label[unit]}`
    }

    const precision = ((unit !== undefined) && (unit !== null)) ? getUnitPrecision(unit) : 2;

    return <div>
        <div onClick={onClick} style={{cursor: 'pointer', color:"#108ee9", margin: "5px"}}>{`${defaultValue}`}</div>
        <Modal open={isModalOpen} onCancel={onModalCancel} onOk={onModalOk}>
            <b>{title}</b><p/>
            <InputNumber style={{width: 200}} placeholder={placeholder} onChange={onQuantityValChange} precision={precision} min={0} value={quantity} max={max} />
        </Modal>
    </div>
}